export default "__VITE_ASSET__8LV2UCUk__"